import { render, staticRenderFns } from "./PageEducatorClassroomRead.vue?vue&type=template&id=5046ec71&scoped=true&"
import script from "./PageEducatorClassroomRead.vue?vue&type=script&lang=js&"
export * from "./PageEducatorClassroomRead.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorClassroomRead.vue?vue&type=style&index=0&id=5046ec71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5046ec71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
